// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ynN5","label":"styles_label__2OlSy"};